import api from '@/shared/api';
import { useMutation } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
export var useChangeCommunicationEmail = function () {
    var intl = useIntl();
    var _a = useMutation(function (values) {
        return api.base
            .post('/api/employee/profile/change-email', values)
            .then(function (res) { return res.data; });
    }, {
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
    }), mutateAsync = _a.mutateAsync, isLoading = _a.isLoading;
    return { changeCommunicationEmail: mutateAsync, isLoading: isLoading };
};
